module.exports = __webpack_public_path__ + "static/assets/a191c2e0d209d4ff173f2c11d6234c99.svg";